import { render, staticRenderFns } from "./VendorMenu.vue?vue&type=template&id=4cb6c02a"
import script from "./VendorMenu.vue?vue&type=script&lang=js"
export * from "./VendorMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports